import React from 'react';
import { LineChartIcon, ShieldCheckIcon, BriefcaseIcon, BuildingIcon, PiggyBankIcon, RefreshCwIcon } from 'lucide-react';
const services = [{
  title: 'Financial Planning',
  description: 'Comprehensive roadmaps tailored to your life goals, risk tolerance, and timeline.',
  icon: LineChartIcon,
  color: 'from-blue-500 to-blue-600'
}, {
  title: 'Tax Strategy',
  description: 'Legal, effective structures to minimize your tax burden and maximize retained earnings.',
  icon: ShieldCheckIcon,
  color: 'from-cyan-500 to-cyan-600'
}, {
  title: 'Wealth Management',
  description: 'Active portfolio management focusing on sustainable, long-term capital growth.',
  icon: BriefcaseIcon,
  color: 'from-teal-500 to-teal-600'
}, {
  title: 'Business Advisory',
  description: 'Strategic consulting for scaling operations, improving margins, and exit planning.',
  icon: BuildingIcon,
  color: 'from-indigo-500 to-indigo-600'
}, {
  title: 'Retirement Planning',
  description: 'Superannuation optimization and transition-to-retirement strategies for peace of mind.',
  icon: PiggyBankIcon,
  color: 'from-purple-500 to-purple-600'
}, {
  title: 'Cash Flow Optimization',
  description: 'Deep-dive analysis into income and expenses to unlock hidden investment capital.',
  icon: RefreshCwIcon,
  color: 'from-sky-500 to-sky-600'
}];
export function ServicesSection() {
  return <section id="services" className="py-24 relative z-10" data-id="element-181">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-184">
            Core Strategies
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-185">
            We don't just give advice; we build robust financial architectures
            designed to withstand market volatility and accelerate growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-186">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} className="group relative p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:bg-white/[0.04] hover:border-white/10 transition-all duration-300 backdrop-blur-sm overflow-hidden" data-id="element-187">
                <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r ${service.color} opacity-0 group-hover:opacity-100 transition-opacity`} data-id="element-188"></div>

                <div className={`inline-flex p-3 rounded-xl bg-gradient-to-br ${service.color} bg-opacity-10 mb-6 group-hover:scale-110 transition-transform`} data-id="element-189">
                  <Icon className="w-6 h-6 text-white" data-id="element-190" />
                </div>

                <h3 className="text-xl font-semibold text-white mb-3" data-id="element-191">
                  {service.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-192">
                  {service.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}